<template>
  <div id="app">
     <router-view
        v-if="['help', 'link', 'confy', 'zxjobchance', 'zxjobDetails', 'zxcompany', 'app-private', 'app-user-private', 'download', 'lotus-api-docs', 'redeem-code'].includes($route.name)"
        style="flex:1;display: flex;"
      />
      <template v-else>
        <Header></Header>
        <router-view style="flex:1;display: flex;z-index: 2;" @on="cur" />
        <Footer></Footer>
      </template>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    cur(sas) {
      console.log(sas);
    }
  }
}
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue